<template>
  <div ref="typeText" v-show="started" style="pointer-events:none;">
    <slot style="pointer-events:none;"></slot>
  </div>
</template>

<script>
export default {
  props: {
   speed:{default:.1},
   delay:{default:0}
  },
  data() {
    return {
      started:false,
      fullText:null,
      text:null,
      output:null
    };
  },
  mounted(){
    this.text=this.$refs.typeText
    this.fullText=this.text.innerHTML.toString()
    this.output=""
    this.text.innerHTML=this.output
    this.started=true
    window.setTimeout(this.revealLetter,this.delay)
    //this.revealLetter()
    
  },
  computed: {
   
     
  },
  methods: {
    revealLetter(){
      
      if(this.output.length==this.fullText.length){
        return
      }
      let line=""

      this.output=this.fullText.substr(0,this.output.length+1)
        if(this.fullText.substr(this.output.length,1)=="<" ){
          //this.text.innerHTML=this.output.substr(0,this.output.length-1)
           window.setTimeout(this.revealLetter,this.speed*1000)
        }else if(this.fullText.substr(this.output.length-1,1)=="<" ){
           window.setTimeout(this.revealLetter,this.speed*1000)
          //this.text.innerHTML=this.output.substr(0,this.output.length-2)
        }else{
          this.text.innerHTML=this.output
           window.setTimeout(this.revealLetter,this.speed*1000)
        }
      
      
    
     

    }
  },
};
</script>

<style lang="scss" scoped>

</style>
